<div matRipple [matRippleDisabled]="!empty" (click)="onContainerClick($event)" [ngClass]="{
		'mat-file-input-drop': !isMatFormField,
		'mat-file-input-is-dragging': isDragging
	}">
	<mat-chip-list [selectable]="false" (click)="$event.stopPropagation(); $event.preventDefault()">
		<mat-chip *ngFor="let file of _values; let index = index" disableRipple removable (removed)="onDeselectFile(index)">
			<mat-icon class="mat-grey" style="margin: 0 4px 0 -4px;">file_upload</mat-icon>
			<div class="mat-chip-text-content">{{file.name}}</div>
			<mat-icon matChipRemove>cancel</mat-icon>
		</mat-chip>
	</mat-chip-list>

	<input hidden (change)="onSelectFiles($any($event.target).files)" #fileInputElement 
		[placeholder]="placeholder" [multiple]="multiple" [accept]="accept" type="file">
	
	<div *ngIf="!isMatFormField && empty" class="mat-grey mat-file-input-placeholder">{{placeholder}}</div>
</div>